import classNames from 'classnames';
import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ActionButton, ButtonPanel } from 'components/secondaryMarket/shared/status';
import { ErrorPanelFooter, ErrorPanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { useSPIntl } from 'hooks/useIntl';
import { useToggleFeature } from 'hooks/useToggleFeature';
import type { IntlKey } from 'locales';

import { Comment } from '../../sidePanel/ready/comment/Comment';
import type { RejectedOrderSidePanelProps } from './RejectedOrderSidePanel.connect';

type HelpCenterButtonOwnProps = Readonly<{
  className?: string;
}>;
function HelpCenterButton({ className }: HelpCenterButtonOwnProps) {
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');
  return helpCenterEnhancement ? (
    <div className={`d-flex ${className}`}>
      <ConnectedHelpCenterButton helpCenterId={RejectedOrderSidePanel.name} />
    </div>
  ) : (
    <LifeRingTrigger e2e="SecondaryPanelContactUs-button" className={`d-flex ${className}`}>
      <button type="button" className="btn btn-default btn-xl m-1 w-100">
        <FormattedMessage id="lifeRing.helpRequest" />
        <em className="icon icon-outlined ms-1">live_help</em>
      </button>
    </LifeRingTrigger>
  );
}

export function RejectedOrderSidePanel({
  onCommentChanged,
  onPlaceOrder,
  errorMessage,
  className,
  timeout,
  hasTimeout,
  isInternalUser,
  comment,
}: RejectedOrderSidePanelProps) {
  const { formatMessage } = useSPIntl();

  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <ErrorPanelHeader>
        {!hasTimeout &&
          formatMessage({ id: (errorMessage as IntlKey) ?? 'generic.error.message', defaultMessage: errorMessage })}
        {hasTimeout &&
          formatMessage(
            {
              id: isInternalUser
                ? 'secondaryMarket.sidePanel.label.internalUserOrderTimeout'
                : 'secondaryMarket.sidePanel.label.externalUserOrderTimeout',
            },
            { timeInMillis: timeout },
          )}
      </ErrorPanelHeader>
      <ErrorPanelFooter
        statusKey={
          hasTimeout
            ? 'secondaryMarket.sidePanel.label.cpOrderFailed'
            : 'secondaryMarket.sidePanel.label.cpOrderRejected'
        }
      />

      <div className="d-flex mt-auto mb-1 w-100">
        <HelpCenterButton className={'w-100 m-1'} />
      </div>

      <ButtonPanel>
        <Comment onCommentChanged={onCommentChanged} comment={comment} />
        <ActionButton
          color="primary"
          label="secondaryMarket.sidePanel.label.placeOrder"
          disabled={false}
          onClick={onPlaceOrder}
        />
      </ButtonPanel>
    </div>
  );
}
